import { stringify } from "query-string";

const HOST = process.env.HOST;

export const errorHandling = (res: any) => {
  if (!res.ok) {
    throw Error(`Opps, something went error... ${res.statusText}`);
  }
  return res;
};

export const getLatestVideos = ({
  id = "PL0wdGU_lCW_Y-mVnwBBzcp93merKQT9VD"
}: {
  id: string;
}) => {
  const config = {
    id
  };
  return fetch(
    `${HOST}/tennis/api/videoapi/GetVideosByPlaylist?${stringify(config)}`
  )
    .then(errorHandling)
    .then(res => res.json());
};

export const getVideo = (id: string) => {
  const config = {
    id
  };
  return fetch(`${HOST}/tennis/api/videoapi/GetVideo?${stringify(config)}`)
    .then(errorHandling)
    .then(res => res.json());
};

export const playlistSearch = (q: string) => {
  const config = {
    searchText: q
  };
  return fetch(`${HOST}/tennis/api/videoapi/searchvideos?${stringify(config)}`)
    .then(errorHandling)
    .then(res => res.json());
};
